import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {
	AmountWithCurrency,
	AmountWithCurrencyResponse,
	DiscountType,
	InvoicePayment,
	PageRequest,
	PaymentsOverview
} from '@models/models';
import { Observable } from 'rxjs';

@Injectable()
export class PaymentsDataServiceProvider {
	id: BehaviorSubject<any> = new BehaviorSubject(false);
	discount: BehaviorSubject<any> = new BehaviorSubject(false);
	discountType: BehaviorSubject<any> = new BehaviorSubject(false);
	issueDate: BehaviorSubject<any> = new BehaviorSubject(false);
	paymentSchedule: BehaviorSubject<any> = new BehaviorSubject(false);
	invoicePayments: BehaviorSubject<any> = new BehaviorSubject(false);
	tax: BehaviorSubject<any> = new BehaviorSubject(false);

	constructor(public http: HttpClient) {}

	get discountObservable() {
		return this.discount.asObservable();
	}

	get idObservable() {
		return this.id.asObservable();
	}

	get issueDateObservable() {
		return this.issueDate.asObservable();
	}

	get discountTypeObservable() {
		return this.discountType.asObservable();
	}

	get paymentScheduleObservable() {
		return this.paymentSchedule.asObservable();
	}

	get invoicePaymentsObservable() {
		return this.invoicePayments.asObservable();
	}

	get taxObservable() {
		return this.tax.asObservable();
	}

	emitId(id: string | boolean) {
		return this.id.next(id);
	}

	emitDiscount(id: number | boolean) {
		return this.discount.next(id);
	}

	emitIssueDate(date: Date | boolean) {
		return this.issueDate.next(date);
	}

	emitDiscountType(type: string | boolean) {
		return this.discountType.next(type);
	}

	emitPaymentSchedule(id: number | boolean) {
		return this.paymentSchedule.next(id);
	}

	emitInvoicePayments(payments: Array<InvoicePayment> | boolean) {
		return this.invoicePayments.next(payments);
	}

	emitTax(tax: number | boolean) {
		return this.tax.next(tax);
	}

	getPaymentsOnPage(pageRequest, paid) {
		const {
			perPage,
			page,
			pageOrder: { predicate, reverse },
			search
		} = pageRequest;
		const url = '/protected/rest/invoice/get_invoices';
		let params = new HttpParams();
		params = params.append('perPage', perPage);
		params = params.append('page', page);
		params = params.append('predicate', predicate);
		params = params.append('reverse', reverse);
		params = params.append('search', search);
		params = params.append('paid', paid);

		return this.http.get(url, { params });
	}

	getTotalDue(isPaidSelected) {
		const url = `/protected/rest/invoices/total_due${isPaidSelected}`;
		return this.http.get(url);
	}

	getPayOnlineLink(id): Observable<any> {
		const url = `/protected/rest/invoices/invoice/payonline/${id}`;
		return this.http.post(url, {});
	}

	getPaymentsV1(paginationRules: PageRequest): Observable<PaymentsOverview> {
		const url = '/api/user/v1/payments/overview';
		return this.http.post<PaymentsOverview>(url, paginationRules);
	}

	getTotalDueV1(
		isPaidSelected: string
	): Observable<AmountWithCurrencyResponse> {
		const url = `/api/user/payments/${isPaidSelected}Amount`;
		return this.http.get<AmountWithCurrencyResponse>(url);
	}

	writeOff(id): Observable<any> {
		const url = `/api/user/payments/${id}/writeoff`;
		return this.http.post(url, {});
	}

	calculatePaymentSchedule(payments): Observable<any> {
		const url = '/api/public/v1/ui/helper/calculate/payment-schedule';
		return this.http.post(url, payments);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/payments/payments-data-service/payments.data.service.ts